/**
 * artworkDisplay -- the ONE rule for what an artwork is CALLED on screen and
 * what TYPE it is (Bug Intake #703).
 *
 * `filename` is the editable display name (PATCH /api/artworks/<id>/name);
 * `original_filename` is the real uploaded file, locked, and the only honest
 * source of the file type. Stored names carry a '#<guid>' identity suffix,
 * stripped by formatArtworkName.
 */
import { formatArtworkName } from "./formatArtworkName";
import { extensionOf } from "./artworkUploadContract";

/**
 * The artwork's display name: the editable name, else the uploaded file's
 * name, else `Artwork #<id>`. null/undefined artwork -> "".
 */
export function artworkDisplayName(artwork) {
  if (!artwork) return "";
  return (
    formatArtworkName(artwork.filename) ||
    formatArtworkName(artwork.original_filename) ||
    `Artwork #${artwork.id}`
  );
}

/** The real file's type for a picker chip ("PDF", "EMB"); "" if unknown. */
export function artworkFileTypeLabel(artwork) {
  if (!artwork) return "";
  const raw = artwork.original_filename || artwork.filename;
  return extensionOf(formatArtworkName(raw)).replace(/^\./, "").toUpperCase();
}
